import React, { useContext, useEffect } from 'react';
import InputField from '../../components/InputField';
import SelectItem from '../../components/SelectItem';
import './../../../styles/irctcCreateAccountForms.css';
import '../../../styles/railSeoSprite.css';
import {
  GENDER_RADIO,
  MARRIAGE_STATUS_RADIO,
  IRCTC_DATE_LIMITS,
  IRCTC_RADIO_BUTTON_NAMES,
  RADIO_KEYS_LABELS_GENDER,
  RADIO_KEYS_LABELS_MARITAL_STATUS,
  CREATE_ACCOUNT_FORM_ELEMENT_ID
} from '../../../utils/RailsSEOConstants';
import IrctcDatePicker from '../../components/IrctcDatePicker';
import { checkValidation, validations } from '../../../utils/FormValidators';
import RadioButtonGroup from '../../components/RadioButtonGroup';
import { IrctcCreateAccountContext } from '../IrctcCreateAccountPage';
import * as irctcCreateAccountActions from './../../../actions/irctcCreateAccountActions';
import PropTypes from 'prop-types';
import { isMobile } from '../../../utils/commonUtils';

const PersonalInfoForm = (props) => {
  const { customClass } = props;

  const context = useContext(IrctcCreateAccountContext);
  const {
    createAccountState: {
      showErrorCreateAccount,
      occupationList,
      firstName,
      lastName,
      selectedDate,
      selectedOccupation,
      selectedGender,
      selectedMaritalStatus,
      selectedPreferredLanguage,
      preferredLanguageList
    },
    createAccountDispatch
  } = context;

  const updateFirstName = (latestFirstName) => {
    createAccountDispatch({
      type: irctcCreateAccountActions.ACTION_SET_FIRST_NAME_CREATE_ACCOUNT,
      data: latestFirstName
    });
  };
  const updateLastName = (latestLastName) => {
    createAccountDispatch({
      type: irctcCreateAccountActions.ACTION_SET_LAST_NAME_CREATE_ACCOUNT,
      data: latestLastName
    });
  };
  const updateSelectedDate = (latestSelectedDate) => {
    createAccountDispatch({
      type: irctcCreateAccountActions.ACTION_SET_SELECTED_DATE_CREATE_ACCOUNT,
      data: latestSelectedDate
    });
  };
  const updateSelectedOccupation = (latestSelectedOccupation) => {
    createAccountDispatch({
      type: irctcCreateAccountActions.ACTION_SET_SELECTED_OCCUPATION_CREATE_ACCOUNT,
      data: latestSelectedOccupation
    });
  };
  const updateSelectedPreferredLanguage = (latestSelectedPreferredLanguage) => {
    createAccountDispatch({
      type: irctcCreateAccountActions.ACTION_SET_SELECTED_PREFERRED_LANGUAGE_CREATE_ACCOUNT,
      data: latestSelectedPreferredLanguage
    });
  };

  const updateRadioButtonValue = (event, actionName) => {
    const value = event.target.id;
    createAccountDispatch({
      type: actionName,
      data: value
    });
  };
  const updateSelectedMaritalStatus = (event) => {
    updateRadioButtonValue(event, irctcCreateAccountActions.ACTION_SET_SELECTED_MARITAL_STATUS_CREATE_ACCOUNT);
  };
  const updateSelectedGender = (event) => {
    updateRadioButtonValue(event, irctcCreateAccountActions.ACTION_SET_SELECTED_GENDER_CREATE_ACCOUNT);
  };

  useEffect(() => {
    // If nothing is selected , then select default radio values
    if (typeof selectedGender !== 'string') {
      updateSelectedGender({
        target: {
          id: GENDER_RADIO.MALE.key
        }
      });
    }
    if (typeof selectedMaritalStatus !== 'string') {
      updateSelectedMaritalStatus({
        target: {
          id: MARRIAGE_STATUS_RADIO.MARRIED.key
        }
      });
    }
  }, []);

  const isMobileDevice = isMobile();
  return (
    <div className={`${customClass} irctcDetailsComp__per`}>
      <div className={`makeFlex ${isMobileDevice ? 'column appendBottom30' : 'appendBottom40'} `}>
        <div id={CREATE_ACCOUNT_FORM_ELEMENT_ID.firstName} />
        {!isMobileDevice && (
          <InputField
            label="Enter your first name"
            placeholder="Enter your first Name"
            customClass="appendRight30"
            value={firstName}
            updateParentValue={updateFirstName}
            error={showErrorCreateAccount && !checkValidation(firstName, validations.firstName)}
            errorMsg={'Enter a valid first name'}
          />
        )}
        {isMobileDevice && (
          <InputField
            label="Enter your first name"
            placeholder="Enter your first Name"
            customClass="appendBottom30"
            value={firstName}
            updateParentValue={updateFirstName}
            error={showErrorCreateAccount && !checkValidation(firstName, validations.firstName)}
            errorMsg={'Enter a valid first name'}
          />
        )}
        <div id={CREATE_ACCOUNT_FORM_ELEMENT_ID.lastName} />
        <InputField
          label="Enter your last name"
          placeholder="Enter your last Name"
          value={lastName}
          updateParentValue={updateLastName}
          errorMsg={'Enter a valid last name'}
          error={showErrorCreateAccount && !checkValidation(lastName, validations.lastName)}
        />
      </div>
      <div className={`makeFlex ${isMobileDevice ? 'column appendBottom30' : 'appendBottom40'}`}>
        <div id={CREATE_ACCOUNT_FORM_ELEMENT_ID.selectedDate} />
        {!isMobileDevice && (
          <IrctcDatePicker
            label="Select your date of birth"
            placeholder="Open calendar and select date"
            customClass="appendRight30"
            selectedDay={selectedDate}
            fromDate={IRCTC_DATE_LIMITS.fromDate}
            toDate={IRCTC_DATE_LIMITS.toDate}
            updateParentDate={updateSelectedDate}
            error={showErrorCreateAccount && !selectedDate}
            errorMsg="Enter a valid date of birth"
          />
        )}
        {isMobileDevice && (
          <IrctcDatePicker
            label="Select your date of birth"
            placeholder="Open calendar and select date"
            customClass="appendBottom30"
            selectedDay={selectedDate}
            fromDate={IRCTC_DATE_LIMITS.fromDate}
            toDate={IRCTC_DATE_LIMITS.toDate}
            updateParentDate={updateSelectedDate}
            error={showErrorCreateAccount && !selectedDate}
            errorMsg="Enter a valid date of birth"
          />
        )}
        <div id={CREATE_ACCOUNT_FORM_ELEMENT_ID.selectedOccupation} />
        <SelectItem
          selectOption={occupationList}
          labelText="Select your occupation"
          selectedIndex={selectedOccupation}
          updateParentIndex={updateSelectedOccupation}
        />
      </div>
      <div className={`makeFlex ${isMobileDevice ? 'column appendBottom30' : 'appendBottom25'} space-between`}>
        <div className={`makeFlex column ${isMobileDevice ? 'appendBottom30' : 'appendRight30'}`}>
          <div id={CREATE_ACCOUNT_FORM_ELEMENT_ID.selectedGender} />
          <RadioButtonGroup
            radioGroupLabel={'Select your gender'}
            radioButtonCustomClass={'radioOuterRails'}
            onRadioOptionClicked={updateSelectedGender}
            value={selectedGender}
            optionsObject={GENDER_RADIO}
            optionsKeysLabels={RADIO_KEYS_LABELS_GENDER}
            optionPurpose={IRCTC_RADIO_BUTTON_NAMES.Gender}
          />
        </div>
        <div id={CREATE_ACCOUNT_FORM_ELEMENT_ID.selectedMaritalStatus} />
        <div className="makeFlex column">
          <RadioButtonGroup
            radioGroupLabel={'Select your marital status'}
            radioButtonCustomClass={'radioOuterRails'}
            onRadioOptionClicked={updateSelectedMaritalStatus}
            value={selectedMaritalStatus}
            optionsObject={MARRIAGE_STATUS_RADIO}
            optionsKeysLabels={RADIO_KEYS_LABELS_MARITAL_STATUS}
            optionPurpose={IRCTC_RADIO_BUTTON_NAMES.MaritalStatus}
          />
        </div>
      </div>
      <div id={CREATE_ACCOUNT_FORM_ELEMENT_ID.selectedPreferredLanguage} />
      <SelectItem
        selectOption={preferredLanguageList}
        labelText="Select your preferred language"
        customClass="halfWidth"
        selectedIndex={selectedPreferredLanguage}
        updateParentIndex={updateSelectedPreferredLanguage}
      />
    </div>
  );
};

PersonalInfoForm.propTypes = {
  customClass: PropTypes.string
};

export default PersonalInfoForm;
